import router from "@/router/index"

const getDefaultState = () => {
  return {
    status: "",
    message: ""
  };
};

const state = getDefaultState();

const mutations = {
  CHANG_CONTENT_ERROR_PAGE(state, payload) {
    state.status = payload.status;
    state.message = payload.message;
  },
};

const actions = {
  redirectErrorPage({ commit }, payload) {
    commit("CHANG_CONTENT_ERROR_PAGE", payload);
    router.push("/error");
  },
};
export default {
  state,
  mutations,
  actions,
};
